export const isTouchDevice = (): boolean => window.matchMedia("(hover: none)").matches;

export const isMobile = (): boolean => window.matchMedia("(max-width: 480px)").matches;

export const isTabletSmall = (): boolean => window.matchMedia("(max-width: 767px)").matches;
